const ModuleIds = [
  'ADMIN',
  'EARCHIVE',
  'ERDS',
  'EINVOICE',
  'EFORMS',
  'EDMS',
  'ESIGN',
  'EVALIDATION',
  'EPROCUREMENT',
  'EREGISTER',
] as const;

export type IModuleId = typeof ModuleIds[number];

export const getCommonElements = (arr1: any[], arr2: any[]) => {
  const set1 = new Set(arr1);
  return arr2.filter(item => set1.has(item));
};
